import { fetchRequestAutoComplete, fetchRequestDetails } from '~/requests';

export const useGetCoordinates = () => async (address: string) => {
  const autoComplete = await fetchRequestAutoComplete(address);
  const placeId = autoComplete?.suggestions?.[0]?.placePrediction?.placeId;
  const detailsResponse = await fetchRequestDetails(placeId);
  const { latitude, longitude } = detailsResponse || {};
  return {
    latitude: Number(Number(latitude).toFixed(7)),
    longitude: Number(Number(longitude).toFixed(7)),
  };
};
